var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgArrowFwdBig = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.2098 6.38702L14.293 6.29282C14.6535 5.93237 15.2207 5.9047 15.613 6.20977L15.7072 6.29297L20.7038 11.2906C21.064 11.6509 21.0919 12.2178 20.7873 12.6101L20.7042 12.7043L15.7076 17.7077C15.3173 18.0985 14.6842 18.0989 14.2934 17.7087C13.9327 17.3484 13.9045 16.7812 14.2093 16.3887L14.2924 16.2945L17.581 13H4C3.48716 13 3.06449 12.614 3.00673 12.1166L3 12C3 11.4872 3.38604 11.0645 3.88338 11.0067L4 11H17.584L14.2928 7.70703C13.9324 7.34651 13.9047 6.77928 14.2098 6.38702L14.293 6.29282L14.2098 6.38702Z",
  fill: "white"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowFwdBig, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-fwd-big.17f0eb1a.svg";
export { ForwardRef as ReactComponent };